module.exports = __webpack_public_path__ + "img/flame_3.06ddb0ab.png";